module.exports = __webpack_public_path__ + "01_medium_gray.8eab4549.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_medium_gray.png
// module id = THWx
// module chunks = 0